module.exports = __webpack_public_path__ + "static/media/bell.29dd3710.mp3";